// External Imports
import { useState } from "react";

// Internal Imports

/** ========================================================================
 * * PlanName Component
 * This component renders formatted text.
 * ========================================================================== */

export default function PlanName({ plan, size = "text-2xl", loading }) {
  const classNames = () => {
    let classes =
      "font-bold text-transparent bg-clip-text bg-gradient-to-br font-Play ";
    if (plan.toLowerCase() === "luxury")
      classes += "from-[#80D0C7] to-[#0093E9] ";
    else if (plan.toLowerCase() === "plush")
      classes += "from-[#F4D03F] to-[#16A085] ";
    else classes += "from-[#FAD961] to-[#F76B1C] ";
    classes += size;
    return classes;
  };

  if (loading)
    return <p className="h-4 rounded-sm animate-pulse bg-stone-700"></p>;
  else return <p className={classNames()}>{plan}</p>;
}
